import { ArrowUpRight } from 'lucide-react';
import { openAssetByKey } from '../../utils/openAssetByKey';

interface OpenAssetButtonProps {
  assetKey?: string;
  name: string;
  assetLabel?: string;
  className?: string;
}

const OpenAssetButton: React.FC<OpenAssetButtonProps> = ({
  assetKey,
  name,
  assetLabel = 'attachment',
  className = 'inline-flex items-center gap-1 text-xs font-medium text-blue-600 hover:underline',
}) => {
  if (!assetKey) return null;

  const isExternal = assetKey.startsWith('http');

  const handleClick = () => {
    if (!isExternal) {
      openAssetByKey(assetKey, assetLabel);
    }
  };

  const content = (
    <div className="flex items-center gap-1">
      <span>{name}</span>
      <ArrowUpRight size={14} />
    </div>
  );

  if (isExternal) {
    return (
      <a
        href={assetKey}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        {content}
      </a>
    );
  }

  return (
    <button type="button" onClick={handleClick} className={className}>
      {content}
    </button>
  );
};

export default OpenAssetButton;
